import React from 'react';
import { Link } from 'react-router-dom';
import linkIcon from 'images/icons/svg/link-1.svg';
import styled from 'styled-components';

interface Props {
  href: string;
  onClick: React.MouseEventHandler<HTMLAnchorElement>;
  text: string;
  disabled?: boolean;
}

const ToolVersionStatsListItem: React.FC<Props> = ({ href, onClick, text, disabled }) => {
  if (disabled) {
    return (
      <Wrapper>
        <span>{text}</span>
      </Wrapper>
    );
  }

  return (
    <Wrapper as={Link} to={href} target="_blank" rel="noopener noreferrer" onClick={onClick}>
      <span>{text}</span>

      <ShowDetailsIcon src={linkIcon} alt="link" />
    </Wrapper>
  );
};

export default ToolVersionStatsListItem;

const Wrapper = styled.div`
  background-color: #b4d0b64d;
  font-size: 14px;
  color: inherit;
  text-decoration: none;
  padding: 14px 16px 14px 16px;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ShowDetailsIcon = styled.img`
  width: 16px;
  height: 16px;
`;
